module.exports = __webpack_public_path__ + "img/原修太.490b067f.png";